import store from "../../redux/store";
import { showSignUp } from "../../redux/actions";
import { EMAIL } from "../../redux/actions/types";
import { checkCustomerExistenceByEmailBackend } from "../../api";
import {
  EMAIL_ALREADY_USED_IN_FIREBASE_AUTH,
  EMAIL_EMPTY_DATA_ACCOUNT,
} from "../../constants";
import { openMessageModal } from "../../utils/common"

import { logHighError } from "../../utils/logger";
import { EMAIL_REGEX } from "../../constants/regex";

export const isUserHasAccount = async (email: string) => {
  try {
    const customer = await checkCustomerExistenceByEmailBackend(email);
    if (!customer.isAuthenticated) {
      store.dispatch({ type: EMAIL, payload: email });
      store.dispatch(showSignUp(true));
    } else {
      if (!customer.userExist) {
        openMessageModal(EMAIL_ALREADY_USED_IN_FIREBASE_AUTH)
      } else {
        store.dispatch({ type: EMAIL, payload: email });
      }
    }
  } catch (error) {
    logHighError(
      `Error checking user account existence ${JSON.stringify(error)}`
    );
    openMessageModal(EMAIL_EMPTY_DATA_ACCOUNT);
  }
};

export const validate = (
  email: string,
  formValues: any,
  isCheckPassword: boolean
) => {
  const errors: any = {};

  const emailValue = email || formValues.email;

  if (!emailValue || !EMAIL_REGEX.test(emailValue)) {
    errors.email = "Merci de fournir adresse e-mail valide";
  }
  if (isCheckPassword && !formValues.password) {
    errors.password = "Merci de fournir un mot de passe";
  }

  return errors;
};
